export default function initCollapsable() {
    document.querySelectorAll('.collapsable').forEach($container => {
        const $toggleCollapse = $container.querySelector('.toggle-collapse');
        const $contentContainer = $container.querySelector('.content-container');

        // Ensure it's focusable if not a button
        if (!$toggleCollapse.hasAttribute('tabindex')) {
            $toggleCollapse.setAttribute('tabindex', '0');
        }
        $toggleCollapse.setAttribute('role', 'button');
        $toggleCollapse.setAttribute('aria-expanded', 'false');

        // Prevent mouse highlighting issues
        $toggleCollapse.addEventListener(
            'mousedown',
            function (e) {
                e.preventDefault();
            },
            false
        );

        // Toggle function
        const toggleContent = () => {
            const isActive = $container.classList.contains('is-active');
            if (isActive) {
                $container.classList.remove('is-active');
                $contentContainer.classList.add('is-hidden');
                $toggleCollapse.setAttribute('aria-expanded', 'false');
            } else {
                $container.classList.add('is-active');
                $contentContainer.classList.remove('is-hidden');
                $toggleCollapse.setAttribute('aria-expanded', 'true');
            }
        };

        // Mouse click
        $toggleCollapse.addEventListener('click', event => {
            if (!event.target.classList.contains('button')) {
                toggleContent();
            }
        });

        // Keyboard: Enter and Space
        $toggleCollapse.addEventListener('keydown', event => {
            const isEnterOrSpace =
                event.key === 'Enter' || event.key === ' '
            if (isEnterOrSpace) {
                event.preventDefault(); // prevent scroll on Space
                toggleContent();
            }
        });
    });
}
